import React, { useContext, useRef, useEffect } from 'react';
import { navigate } from 'gatsby';
import Context from '../context/ContextStorefront';
import cx from 'classnames';
import { SwitchTransition, Transition } from 'react-transition-group';

const TRANSITION_DURATION = 400;

const TRANSITION_STYLES = {
    default: {
        transition: `opacity ${TRANSITION_DURATION}ms ease, transform ${TRANSITION_DURATION}ms ease`,
        transform: 'translateY(20px)',
    },
    entering: {
        opacity: 0,
        transform: 'translateY(20px)',
    },
    entered: {
        opacity: 1,
        transform: 'translateY(0px)',
    },
    exiting: {
        opacity: 0,
        transform: 'translateY(20px)',
    },
    exited: {
        opacity: 0,
    },
};

const SearchForm = ({ enableBanner }) => {
    const { isSearchOpen, setSearchOpen } = useContext(Context);
    const containerElement = useRef(null);
    const inputElement = useRef(null);

    const handleSearch = event => {
        event.preventDefault();
        const query = event.target.searchTerm.value;
        setSearchOpen(false);
        navigate(`/search?q=${query}`);
    };

    const escapeKey = e => {
        if (e.key === 'Escape') {
            setSearchOpen(false);
        }
    };
    useEffect(() => {
        if (isSearchOpen) {
            setTimeout(() => {
                inputElement.current.focus();
            }, 500);

            window.addEventListener('keydown', escapeKey);
        } else {
            window.removeEventListener('keydown', escapeKey);
        }
    }, [isSearchOpen]);

    return (
        <section
            className={cx('search pf fill df fdc jcc aic', {
                open: isSearchOpen,
                'banner-open': enableBanner,
            })}
            ref={containerElement}
            onClick={e => {
                if (e.target === containerElement.current) {
                    setSearchOpen(false);
                }
            }}
        >
            <SwitchTransition>
                <Transition key={isSearchOpen} appear timeout={50}>
                    {status => (
                        <form
                            className="search__form df fdc jcc aic"
                            onSubmit={handleSearch}
                            style={{
                                ...TRANSITION_STYLES.default,
                                ...TRANSITION_STYLES[status],
                            }}
                        >
                            <label
                                htmlFor="searchTerm"
                                className="search__label db x"
                            >
                                <input
                                    className="search__input db x bb--black serif--47 serif--80--lg pb2 tc"
                                    name="searchTerm"
                                    id="searchTerm"
                                    type="text"
                                    ref={inputElement}
                                />
                            </label>
                            <button className="db button--primary mt5">
                                Search
                            </button>
                        </form>
                    )}
                </Transition>
            </SwitchTransition>
        </section>
    );
};

export default SearchForm;